module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcAgMAAAAPYzcHAAAADFBMVEUAAAAAAAAAAAAAAAA16TeWAAAAA3RSTlMASePizoNQAAAANUlEQVQI12NgIADY/oPABAZuMP0ATsPECYP8/z/B9P7//1BomDhB7f/BCvcD6X9INEwcPwAAoykzcz5ylIcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourseImages/jz-1@2x.png
// module id = 0lw8
// module chunks = 96